import axios from 'axios';

// Define a URL base da API dinamicamente
const BASE_API =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000/api' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br/api'; // URL para ambiente de produção

console.log('Base API:', BASE_API); // Apenas para conferir qual URL está sendo usada

// Configura uma instância do Axios com opções padrão
const api = axios.create({
  baseURL: BASE_API,
  timeout: 10000, // 10 segundos de timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Função para cadastrar um gerente
export const cadastrarGerente = async (dadosGerente) => {
    console.log('Entrou no cadastrarGerente do Api.js...');
    console.log('Dados enviados:', dadosGerente);
  
    const endpoint = '/user/cadastrargerente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dadosGerente);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao cadastrar gerente:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
// Função para buscar dados do estabelecimento
export const buscarDadosEstabelecimento = async (userData) => {
    console.log('Entrou no buscarDadosEstabelecimento do Api.js...');
    console.log('Dados enviados:', userData);
  
    const endpoint = '/estabelecimento/buscarDadosEstabelecimento';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, userData);

      console.log('retorno: ');
      console.log(response.data);

      return response.data; // Retorna a resposta do backend
      
    } catch (error) {
      console.error('Erro ao buscar dados do Estabelecimento:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };

// Função para buscar estabelecimentos
export const buscarEstabelecimentos = async (userData) => {
    console.log('Entrou no buscarEstabelecimentos do Api.js...');
    console.log('Dados enviados:', userData);
    console.log('latitude enviada:', userData.latitude);
    console.log('longitude enviada:', userData.longitude);
  
    const endpoint = '/estabelecimento/buscarEstabelecimentos';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, userData);

      console.log('retorno: ');
      console.log(response.data);

      return response.data; // Retorna a resposta do backend
      
    } catch (error) {
      console.error('Erro ao buscar Estabelecimentos:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
// Função para salvar a edição dos dados do estabelecimento
export const salvarEdicaoDadosEstabelecimento = async (userData, formData) => {
  console.log('Entrou no salvarEdicaoDadosEstabelecimento do Api.js...');
  console.log('Dados que serão enviados:', formData);

  // Verifica o conteúdo do FormData
  formData.forEach((value, key) => {
    console.log(key, value);
  });

  const endpoint = '/estabelecimento/salvarEdicaoDadosEstabelecimento';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await axios.post(fullUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.token}`,  // Certifique-se de que o token está sendo enviado
      },
    });

    console.log('Retorno:', response.data);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao salvar os dados do Estabelecimento:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

  
// Função para cadastrar um gerente
export const efetuarLogin = async (dados) => {
    console.log('Entrou no efetuarLogin do Api.js...');
    console.log('Dados enviados:', dados);
  
    const endpoint = '/auth/loginBarInteligente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dados);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao efetuar login:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  

// Exporta o Axios para uso genérico, se necessário
export default api;
